import { DanaSendOrderDetailsEmailApiParameter, sendOrderDetailsEmail } from "@dana/Services/DanaOrderRelatedService";
import { OrderDetailEmail } from "@dana/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,    
} from "@insite/client-framework/HandlerCreator";


type PostOrderDetailsEmailParameter = {
    recipientEmailAddress?: string;
    orderPackingSlipResponse?: OrderDetailEmail;
    packingHtml:string;
    invoiceType:string;
  
}& HasOnSuccess<any> & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<PostOrderDetailsEmailParameter, DanaSendOrderDetailsEmailApiParameter>;

export const SendDataToApi: HandlerType = async props => {
   await sendOrderDetailsEmail({
        recipientEmailAddress:props.parameter.recipientEmailAddress,  
        orderPackingSlipResponse: props.parameter.orderPackingSlipResponse,
        packingHtml:props.parameter.packingHtml,
        invoiceType:props.parameter.invoiceType,        
    });
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [SendDataToApi];

const PostOrderDetailsEmailHandler = createHandlerChainRunner(chain, "PostOrderDetailsEmailHandler");
export default PostOrderDetailsEmailHandler;